import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { HeadersName } from '@workspace/data-types';
import { environment } from '@workspace/ng-config';
import { ClientMetadataService } from '../services/client-metadata.service';

export const ClientMetadataInterceptor: HttpInterceptorFn = (req, next) => {
  if (typeof window === 'undefined' || req.url.includes(`${environment.auth.keycloak.host}/realms/`)) {
    return next(req);
  }
  const clientMetadata = inject(ClientMetadataService);
  const m = clientMetadata.collect();

  const headers: Record<string, string> = {
    [HeadersName.X_APP_TZ]: m.tz,
    [HeadersName.X_APP_RES]: m.resolution,
    [HeadersName.X_APP_LANG]: m.lang,
    [HeadersName.X_CLIENT_ID]: m.clientId,
  };

  if (m.pixelRatio != null) {
    headers[HeadersName.X_APP_PIXEL_RATIO] = m.pixelRatio.toString();
  }
  if (m.cores != null) {
    headers[HeadersName.X_APP_CORES] = m.cores.toString();
  }
  if (m.memory != null) {
    headers[HeadersName.X_APP_MEM] = m.memory.toString();
  }

  const cloned = req.clone({ setHeaders: headers });
  return next(cloned);
};
